// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2re0H","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1f4mx"};